import { Component, Input } from '@angular/core';

import { Rodeo } from '../../../../../model/rodeo';
import { ModalController, ToastController, AlertController, LoadingController, Events, PopoverController } from 'ionic-angular';
import { AlertMessager } from '../../../../../lib/alertMessager';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { PaymentService } from '../../../../../services/payment.service';
import { Organization } from '../../../../../model/organization';
import { SearchComponent } from '../../../../search/search.component';
import { RunService } from '../../../../../services/run.service';
import { TeamService } from '../../../../../services/team.service';
import { Team } from '../../../../../model/team';
import { Account } from '../../../../../model/account';
import { TeamPopupModal } from './team-popup';
import { AccountTeam } from '../../../../../model/accountTeam';
import { LeaderGenerator } from '../../../../../lib/leaderGenerator';
import { TeamSelectPopup } from './team-select';
import { PayoutConfig } from 'model/payoutConfig';

@Component({
    selector: 'page-teams',
    templateUrl: 'teams.html'
})
export class TeamSection {
    _rodeo: Rodeo;
    _teams: Team[];

    accountIdMapping: Map<number, Account> = new Map<number, Account>();
    accountPoints: Map<number, number> = new Map<number, number>();
    accountList: Account[];

    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    teamSearchChangeObservable;
    teamResults: Team[] = [];
    name: string;

    _organizations: any[] = [];

    popoverActive: boolean;
    loadingData: boolean;

    nameSortAsc: boolean = true;
    nameSortDesc: boolean;
    pointSortAsc: boolean;
    pointSortDesc: boolean;

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;

            this.mapRunAccounts();
            this.mapAccountPoints();
            this.filterTeams();
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set organizations(organizations: Organization[]) {
        if (organizations != null) {
            this._organizations = organizations;
        }
    }
    get organizations(): Organization[] {
        return this._organizations;
    }

    constructor(private modalCtrl: ModalController, private alertController: AlertController, private alert: AlertMessager, private loadingController: LoadingController,
        private toast: ToastController, private popoverController: PopoverController, private paymentService: PaymentService,
        public events: Events, private teamService: TeamService, private runService: RunService) {
        this.events.subscribe("RunChangesHappened", (data) => this.mapRunAccounts());
        this.events.subscribe("WinnersChanged", (data) => this.mapAccountPoints());
        setTimeout(() => {
            this.loadTeams();
        })
    }

    async loadTeams() {
        this._teams = await this.teamService.getTeams(this.rodeo.id);

        this.updateTeamPoints();
        this.filterTeams();
    }

    mapAccountPoints() {
        this.accountPoints = new Map<number, number>();

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            if (rodeoEvent.winners.length == 0)
                return;

            var payoutConfig = {} as PayoutConfig;

            rodeoEvent.winners.forEach((winner) => {
                if (winner.payoutConfigId != payoutConfig.id) {
                    payoutConfig = this.rodeo.payoutConfigs.filter(x => x.id == winner.payoutConfigId)[0];
                }

                if (!payoutConfig || !payoutConfig.sources || payoutConfig.sources.length == 0)
                    return;

                let leaders = LeaderGenerator.instance().getLeaders(this.rodeo, payoutConfig, 9999, true, true, rodeoEvent.fallBackToPlace)

                leaders.forEach(group => {
                    group.runs.forEach((run, index) => {
                        run.points = Math.max(0, 60 + (-10 * index)) * 1;

                        var currentIndex = index;
                        while (currentIndex > 0) {
                            if (group.mode.isAggregate || group.mode.isAverage) {
                                if (!rodeoEvent.configuration.runs.scoreValue) {
                                    if (run.totalTime == group.runs[currentIndex - 1].totalTime) {
                                        run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                    } else {
                                        break;
                                    }
                                } else {
                                    if (run.totalScore == group.runs[currentIndex - 1].totalScore) {
                                        run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                    } else {
                                        break;
                                    }
                                }
                            } else {
                                if (!rodeoEvent.configuration.runs.scoreValue) {
                                    if (run.time == group.runs[currentIndex - 1].time) {
                                        run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                    } else {
                                        break;
                                    }
                                } else {
                                    if (run.score == group.runs[currentIndex - 1].score) {
                                        run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                    } else {
                                        break;
                                    }
                                }
                            }

                            currentIndex--;
                        }

                        if (index > 0) {
                            var newPoints = run.points / (index - currentIndex + 1);

                            while (currentIndex <= index) {
                                group.runs[currentIndex].points = newPoints.toFixed(1);
                                currentIndex++;
                            }
                        }
                    });

                    group.runs.forEach((run) => {
                        if (!this.accountPoints.has(run.contestantOneId))
                            this.accountPoints.set(run.contestantOneId, 0);

                        this.accountPoints.set(run.contestantOneId, this.accountPoints.get(run.contestantOneId) + Number(run.points) * 1);

                        if (run.contestantTwoId) {
                            if (!this.accountPoints.has(run.contestantTwoId))
                                this.accountPoints.set(run.contestantTwoId, 0);

                            this.accountPoints.set(run.contestantTwoId, this.accountPoints.get(run.contestantTwoId) + Number(run.points) * 1);
                        }
                    })
                });
            });
        })

        this.updateTeamPoints();
    }

    mapRunAccounts() {
        this.accountIdMapping = new Map<number, Account>();
        this._rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).forEach(run => {
            this.accountIdMapping.set(run.contestantOneId, run.contestantOne);

            if (run.contestantTwoId)
                this.accountIdMapping.set(run.contestantTwoId, run.contestantTwo);
        });

        this.accountList = Array.from(this.accountIdMapping.values());
    }

    updateTeamPoints() {
        if (this._teams) {
            this._teams.forEach((team) => {
                team.points = 0;
                team.contestants.forEach((contestant) => {
                    if (this.accountPoints.has(contestant.accountId)) {
                        team.points += this.accountPoints.get(contestant.accountId) * 1;
                    }
                })
            })
        }
    }

    onNameSearchChange(searchValue: string) {
        if (!this.teamSearchChangeObservable) {
            Observable.create(observer => {
                this.teamSearchChangeObservable = observer;
            }).debounceTime(300)
                .distinctUntilChanged()
                .subscribe((text) => { this.filterTeams() });
        }

        this.teamSearchChangeObservable.next(searchValue);
    }

    addContestantToTeam() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(TeamSelectPopup, {
            teams: this._teams
        }, { cssClass: 'page-team-select' });

        popover.present();

        popover.onDidDismiss(async (data) => {
            if (!data)
                return;
            
            var team = data.team as Team;
            popover = this.popoverController.create(SearchComponent, {
                config: {
                    searchTitle: "Contestant Search",
                    userSearch: true,
                    addNew: false
                },
                organizations: this.organizations,
                accountSearchList: this.accountList
            }, { cssClass: 'app-search' });

            popover.present();

            popover.onDidDismiss(async (data) => {
                this.popoverActive = false;

                if (data != null) {
                    if (data.id > 0) {
                        await this.teamService.addContestantToTeam(team.id, data.id)
                            .then(data => {
                                if (!team.contestants)
                                    team.contestants = [];

                                team.contestants.push(data as AccountTeam);

                                this.updateTeamPoints();
                            }, error => {
                                this.alert.showError("Contestant Add Error", error.error);
                            });
                    }
                }
            })
        });
    }

    filterTeams() {
        this.teamResults = this._teams;

        if (this.name) {
            const matchingAccounts = this.accountList.filter(x => x.firstName.toLowerCase().indexOf(this.name.toLocaleLowerCase()) != -1 || x.lastName.toLowerCase().indexOf(this.name.toLocaleLowerCase()) != -1);
            this.teamResults = this.teamResults.filter(x => x.name.toLowerCase().indexOf(this.name.toLocaleLowerCase()) != -1 || x.contestants.find(y => matchingAccounts.find(z => z.id == y.accountId) != null) != null);
        }

        if (!this.teamResults)
            this.teamResults = [];

        this.sortTeams();
    }

    toggleNameSort() {
        if (this.nameSortAsc) {
            this.nameSortAsc = false;
            this.nameSortDesc = true;
        } else {
            this.nameSortAsc = true;
            this.nameSortDesc = false;
            this.pointSortAsc = false;
            this.pointSortDesc = false;
        }

        this.sortTeams();
    }

    togglePointSort() {
        if (this.pointSortAsc) {
            this.pointSortAsc = false;
            this.pointSortDesc = true;
        } else {
            this.nameSortAsc = false;
            this.nameSortDesc = false;
            this.pointSortAsc = true;
            this.pointSortDesc = false;
        }

        this.sortTeams();
    }

    sortTeams() {
        this.teamResults.sort((n1, n2) => {
            if (this.pointSortAsc || this.pointSortDesc) {
                if (n1.points < n2.points)
                    return this.pointSortDesc ? 1 : -1;
                else if (n1.points > n2.points)
                    return this.pointSortDesc ? -1 : 1;

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            } else if (this.nameSortAsc || this.nameSortDesc) {
                if (n1.name < n2.name)
                    return this.nameSortDesc ? 1 : -1;
                else if (n1.name > n2.name)
                    return this.nameSortDesc ? -1 : 1;

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            }
        });
    }

    addNewTeam() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(TeamPopupModal, {
            rodeo: this.rodeo
        }, {
            cssClass: 'team-popup'
        });

        popover.present();

        popover.onDidDismiss(async (data) => {
            this.popoverActive = false;

            if (data) {
                this.popoverActive = true;

                (data as Team).rodeoId = this.rodeo.id;
                var team = await this.teamService.addTeam(data as Team);
                this.popoverActive = false;

                if (team) {
                    this._teams.push(team);
                }

                this.filterTeams();
            }
        })
    }

    deleteTeam(team: Team) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Team Removal',
            message: `Are you sure you want to remove ${team.name}?`,
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.teamService.removeTeam(team.id)
                            .then(data => {
                                this._teams = this._teams.filter(x => x != team);
                                this.filterTeams();

                                this.popoverActive = false;
                            }, error => {
                                this.alert.showError("Team Removal Error", error.error);
                                this.popoverActive = false;
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    removeContestantFromTeam(team: Team, contestant: AccountTeam) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Contestant Removal',
            message: `Are you sure you want to remove ${this.accountIdMapping.get(contestant.accountId).firstName} ${this.accountIdMapping.get(contestant.accountId).lastName}?`,
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.teamService.removeContestantFromTeam(team.id, contestant.accountId)
                            .then(data => {
                                team.contestants = team.contestants.filter(x => x.accountId != contestant.accountId);
                                this.filterTeams();
                                this.updateTeamPoints();

                                this.popoverActive = false;
                            }, error => {
                                this.alert.showError("Team Removal Error", error.error);
                                this.popoverActive = false;
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/teams/teams.ts